module.exports = __webpack_public_path__ + "static/media/bg-card_pricing-helper.d3df9522.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg/bg-card_pricing-helper.jpg
// module id = 1496
// module chunks = 0